class Store {
  constructor(data) {
    this.ikyuRestaurantId = data.ikyu_restaurant_id?.split(',') || [];
    this.ikyuAccommodationId = data.ikyu_accommodation_id;
    this.shortName = data.short_name;
    this.shopName = data.shop_name;
    this.shopNameKana = data.shop_name_kana;
    this.shopGenreCategory = data.shop_genre_category;
    this.shopGenreCategorySub = data.shop_genre_category_sub;
    this.profileImageUrl = data.profile_image_url;
    this.description = data.description;
    this.shopPrefecture = data.shop_prefecture;
    this.shopPostalCode = data.shop_postal_code;
    this.shopAddressCity = data.shop_address_city;
    this.shopAddressStreet = data.shop_address_street;
    this.shopAddressBuilding = data.shop_address_building;
    this.shopPhoneNumber = data.shop_phone_number;
    this.shopContactInfo = data.shop_contact_info;
    this.bannerImageUrl = data.banner_image_url;
    this.announcement = {
      content: data.announcement_content,
      startDate: data.announcement_start_date ? new Date(data.announcement_start_date) : null,
      endDate: data.announcement_end_date ? new Date(data.announcement_end_date) : null
    };
    this.isFurusato = window.isFurusato;
  }

  // 完全な住所を取得
  getFullAddress() {
    const parts = [
      this.shopPostalCode,
      this.shopPrefecture,
      this.shopAddressCity,
      this.shopAddressStreet,
      this.shopAddressBuilding
    ];
    return parts.filter(part => part).join(' ');
  }

  // お知らせが有効かどうかを確認
  hasValidAnnouncement() {
    if (!this.announcement.content) return false;
    
    const now = new Date();
    const isAfterStart = !this.announcement.startDate || now >= this.announcement.startDate;
    const isBeforeEnd = !this.announcement.endDate || now <= this.announcement.endDate;
    
    return isAfterStart && isBeforeEnd;
  }

  // 店舗情報をHTMLエレメントに反映
  updateElements() {
    this.updateStoreName();
    this.updateLocation();
    
    if (!this.isFurusato) {
      this.updateHeadImage();
      this.updateDescription();
      this.updateGenre();
      this.updateAnnouncement();
    }
  }

  updateStoreName() {
    const elements = {
      'head-image': this.bannerImageUrl,
      'store-name': this.shopName,
      'info-location': `${this.shopPrefecture} ${this.shopAddressCity}`,
      'genre-main': this.shopGenreCategory,
      'genre-sub': this.shopGenreCategorySub
    };

    for (const [id, value] of Object.entries(elements)) {
      const element = document.getElementById(id);
      if (element) {
        if (id === 'head-image') {
          element.src = value || window.noImageUrl;
          element.alt = this.shopName;
        } else {
          element.textContent = value || '';
        }
      }
    }

    const headImageBg = document.getElementById('head-image-bg');
    if (headImageBg) {
      headImageBg.dataset.url = this.bannerImageUrl || '';
      // Alpine.jsのデータを更新
      if (headImageBg._x_dataStack) {
        headImageBg._x_dataStack[0].bgUrl = this.bannerImageUrl || '';
      }
    }

    // ジャンルタグのリンクURLを設定
    const genreMainLink = document.getElementById('genre-main-link');
    const genreSubLink = document.getElementById('genre-sub-link');
    const genreSubElement = document.getElementById('genre-sub');

    let urlParams = new URLSearchParams('');  // デフォルト値として空の文字列で初期化

    // Get URL parameters
    const currentUrl = window.location.href;
    const hasParams = currentUrl.includes('?');
    if (hasParams) {
      urlParams = new URLSearchParams(currentUrl.split('?')[1]);
    }

    if (genreMainLink && this.shopGenreCategory) {
      const url = `/pages/vendors?t1=${encodeURIComponent(this.shopGenreCategory)}`;
      if (urlParams.get('takeout') === 'true') {
        genreMainLink.href = `${url}&takeout=true`;
      } else {
        genreMainLink.href = url;
      }
    }
    if (genreSubLink && genreSubElement && this.shopGenreCategorySub) {
      const url = `/pages/vendors?t1=${encodeURIComponent(this.shopGenreCategorySub)}`;
      if (urlParams.get('takeout') === 'true') {
        genreSubLink.href = `${url}&takeout=true`;
      } else {
        genreSubLink.href = url;
      }
    }
  }

  updateLocation() {
    const location = document.getElementById('info-location');
    if (location) {
      location.textContent = `${this.shopPrefecture} ${this.shopAddressCity}`;
    }
  }

  updateHeadImage() {
    const headImage = document.getElementById('head-image');
    if (headImage) {
      headImage.src = this.bannerImageUrl || window.noImageUrl;
      headImage.alt = this.shopName;
    }
  }

  updateDescription() {
    const description = document.getElementById('description');
    if (description && this.description) {
      description.innerHTML = this.description;
    }
  }

  updateGenre() {
    const genreMain = document.getElementById('genre-main');
    const genreSub = document.getElementById('genre-sub');
    if (genreMain && this.shopGenreCategory) {
      genreMain.textContent = this.shopGenreCategory;
    }
    if (genreSub && this.shopGenreCategorySub) {
      genreSub.textContent = this.shopGenreCategorySub;
    }
  }

  updateAnnouncement() {
    const announcementContainer = document.getElementById('announcement-container');
    const announcement = document.getElementById('announcement');
    if (this.hasValidAnnouncement() && announcementContainer && announcement) {
      const content = this.announcement.content;
      announcement.innerHTML = content
        .replace(/\n{2,}/g, '')
        .replace(/\n/g, '<br>')
        .replace(/(https?:\/\/\S+)/g, (url) => 
          `<a href="${url}" class="tw-text-[#B7583D] tw-underline" target="_blank" rel="noopener noreferrer">${url}</a>`
        );
      announcementContainer.classList.remove('tw-hidden');
    }
  }
}